export default __webpack_public_path__ + "static/media/wallet-faq.f1cf9a1a.pdf";